import { Window } from 'styles/Window'

const NotFound = () => {

  return (
    (
    <Window>
      <p className="pagetitle">404</p>
      <p>This page does not exist!</p>
      <p>Use the bar on top to go back to a real page.</p>
    </Window>
    )
  )
};

export default NotFound;
